export default __webpack_public_path__ + "static/media/data_not_found.2d6df8bd.gif";